import type { ReactNode } from 'react';
import { usePermissions } from '../hooks/usePermissions.ts';

interface Props {
  children: ReactNode;
}

export function RequireAdmin({ children }: Props) {
  const { isAdmin } = usePermissions();
  if (!isAdmin) {
    return (
      <div className='min-h-screen bg-background flex items-center justify-center'>
        <div className='text-center'>
          <h1 className='text-2xl font-bold'>404 - Page not found</h1>
          <p className='text-muted-foreground mt-2'>
            The page you're looking for doesn't exist.
          </p>
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
